'use client'

import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'

import useTranslations from '../../hooks/useTranslations'

type Props = {
  forHtml?: boolean
}
export const SponsorBlockTitle = ({ forHtml }: Props) => {
  const $t = useTranslations()

  return (
    <Typography
      className={forHtml ? undefined : 'text-center'}
      element="p"
      inlineStyle={forHtml}
      style={forHtml ? { textAlign: 'center' } : {}}
      variant="heading-4"
    >
      {$t('sponsor.title')}
    </Typography>
  )
}
